import { Controller } from '@hotwired/stimulus'
import OnDemandAttendanceVerification from 'cle/on_demand_attendance_verification'

import { BackwardControl, ForwardControl, StepForwardControl } from 'cle/player_controls/custom_seek_control'
import { CustomPlayControl } from 'wistia/player_controls/custom_play_control'
import DisplayCurrentTimeControl from 'cle/player_controls/display_current_time_control'
import Modal from 'components/modal'

export default class extends Controller {

  static values = {
    videoName: String,
    videoId: String,
    checkpoints: Array,
    attendanceTemplate: String,
    attendancePopupContainerSelector: String,
    attendancePopupInstructionsSelector: String,
    attendancePopupCountDownContainerSelector: String,
    attendancePopupCountDownSeconds: Number,
    attendancePopupConnectionErrorContainerSelector: String,
    attendanceExpiredTemplate: String,
    videoEndToleranceSeconds: Number,
    simultaneousVideoAlertTemplate: String,
    simultaneousVideoAlertContainerSelector: String,
    attendanceUrl: String,
    attendanceAlreadyCompleted: Boolean,
    contentViewsUrl: String,
    attendanceVerificationAudioUrl: String
  }

  initialize(){
    try {
      this.setupAttendanceVerification()
      this.defineWistiaControls()
    } catch(e) {
      if(window.Rollbar) { window.Rollbar.error(e) }
      this.showFatalErrorModal(e)
      throw(e)
    }
  }

  setupAttendanceVerification(){
    this.attendanceVerification = new OnDemandAttendanceVerification({
      videoName: this.videoNameValue,
      videoID: this.videoIdValue,
      checkpoints: this.checkpointsValue,
      attendanceTemplate: this.attendanceTemplateValue,
      attendancePopupContainerSelector: this.attendancePopupContainerSelectorValue,
      attendancePopupInstructionsSelector: this.attendancePopupInstructionsSelectorValue,
      attendancePopupCountDownContainerSelector: this.attendancePopupCountDownContainerSelectorValue,
      attendancePopupCountDownSeconds: this.attendancePopupCountDownSecondsValue,
      attendancePopupConnectionErrorContainerSelector: this.attendancePopupConnectionErrorContainerSelectorValue,
      attendanceExpiredTemplate: this.attendanceExpiredTemplateValue,
      videoEndToleranceSeconds: this.videoEndToleranceSecondsValue,
      simultaneousVideoAlertTemplate: this.simultaneousVideoAlertTemplateValue,
      simultaneousVideoAlertContainerSelector: this.simultaneousVideoAlertContainerSelectorValue,
      attendanceUrl: this.attendanceUrlValue,
      attendanceAlreadyCompleted: this.attendanceAlreadyCompletedValue,
      contentViewsUrl: this.contentViewsUrlValue,
      attendanceVerificationAudioUrl: this.attendanceVerificationAudioUrlValue
    }, Modal, window.Rollbar && window.Rollbar.captureEvent.bind(window.Rollbar), (e) => { this.showFatalErrorModal(e) }, window.Rollbar)
  }

  onReady(evt) {
    try {
      this.attendanceVerification.run(evt.detail.video, Modal)
    } catch (e) {
      if(window.Rollbar) window.Rollbar.error(e)
      this.showFatalErrorModal(e)
      throw(e)
    }
  }

  showFatalErrorModal(e){
    // If the error is related to CSRF we ask the user to sign in again and
    // refresh the page.
    if (e.response.status === 422 && e.response.body.match(/change you wanted was rejected|CSRF/)) {
      Modal.show("sign-in-form-cle-course")
    } else {
      Modal.show("fatal_error_modal")
    }
  }

  defineWistiaControls() {
    window.addEventListener("load", (event) => {
      if (typeof(Wistia) === "object" && typeof(Wistia.defineControl) === "function") {
        Wistia.defineControl(BackwardControl)
        Wistia.defineControl(ForwardControl)
        Wistia.defineControl(StepForwardControl)
        Wistia.defineControl(CustomPlayControl)
        Wistia.defineControl(DisplayCurrentTimeControl)
      }
    }, { once: true })
  }
}
